/**
 * GloveBrandTabs — the brand switcher that lives on top of every gloves
 * page (AMMEX + Ansell today; add more brands here as they ship).  Kept in
 * a shared component so the tab strip never disappears when a buyer
 * navigates between brands.
 */
import { Link, useLocation } from "react-router-dom";

const BRANDS = [
  { path: "/marketplace/gloves",         label: "AMMEX",  count: 27,  testid: "brand-tab-ammex"  },
  { path: "/marketplace/gloves/ansell",  label: "Ansell", count: 513, testid: "brand-tab-ansell" },
];

export default function GloveBrandTabs() {
  const { pathname } = useLocation();
  return (
    <div className="flex items-center gap-2 flex-wrap">
      <span className="text-[10px] font-black uppercase tracking-[1.5px] text-slate-500 shrink-0 mr-1">
        Brand:
      </span>
      {BRANDS.map((b) => {
        const active = pathname === b.path;
        return (
          <Link
            key={b.path}
            to={b.path}
            data-testid={b.testid}
            className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs font-bold border transition-colors ${
              active
                ? "bg-slate-900 text-white border-slate-900"
                : "bg-white text-slate-700 border-slate-300 hover:border-blue-500 hover:text-blue-700"
            }`}
          >
            {b.label}
            <span className={`inline-flex items-center justify-center min-w-[22px] h-4 px-1 rounded text-[10px] font-black ${
              active ? "bg-white text-slate-900" : "bg-slate-100 text-slate-600"
            }`}>
              {b.count}
            </span>
          </Link>
        );
      })}
    </div>
  );
}
